( function( app ) {
  const COMPONENT = {

    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.resource-select__select-btn' ).on( 'toggleAfter', ( event ) => {
        if ( window.matchMedia( '(max-width: 1023px)' ).matches ) {
          $( event.target ).next().slideToggle();
        }
      } );


      function handleMobileChange( event ) {
        if ( event.matches ) {
          if ( $( '.resource__select-btn' ).hasClass( 'is-open' ) ) {
            forceToggle();
          }
          $( '.resource-select__dropdown' ).get( 0 ).style.removeProperty( 'display' );
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 1024px)' );
      mobileSize.addEventListener( 'change', handleMobileChange );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'resource', COMPONENT );
} )( app );
